import React, { lazy, Suspense } from 'react'

const ExcelUploaderSkeleton = () => {
    return (
        <div className="max-w-6xl mx-auto animate-pulse">
            {/* Title Skeleton */}
            <div className="mb-6">
                <div className="h-8 w-64 bg-gray-200 rounded-md"></div>
            </div>

            {/* Steps Indicator Skeleton */}
            <div className="mb-8">
                <div className="flex items-center justify-center px-4">
                    <div className="flex items-center w-full max-w-4xl space-x-4">
                        {[1, 2, 3, 4].map((step) => (
                            <div key={step} className="flex items-center flex-1">
                                <div className="flex items-center">
                                    {/* Step Circle */}
                                    <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
                                        <div className="w-4 h-4 bg-gray-300 rounded-full"></div>
                                    </div>
                                    {/* Step Label */}
                                    <div className="ml-3 flex-1">
                                        <div className="h-4 w-20 bg-gray-200 rounded mb-1"></div>
                                        <div className="h-3 w-16 bg-gray-100 rounded"></div>
                                    </div>
                                </div>
                                {/* Connector Line */}
                                {step < 4 && <div className="flex-1 h-0.5 mx-3 bg-gray-200"></div>}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Main Content Card Skeleton */}
            <div className="bg-white shadow-lg rounded-lg overflow-hidden p-6">
                {/* Upload Area Skeleton */}
                <div className="max-w-4xl mx-auto">
                    {/* Header */}
                    <div className="text-center mb-8">
                        <div className="w-16 h-16 bg-gray-200 rounded-full mx-auto mb-4"></div>
                        <div className="h-6 w-48 bg-gray-200 rounded mx-auto mb-2"></div>
                        <div className="h-4 w-64 bg-gray-100 rounded mx-auto"></div>
                    </div>

                    {/* Upload Area */}
                    <div className="border-2 border-dashed border-gray-200 rounded-xl p-12 text-center mb-8">
                        <div className="w-20 h-20 bg-gray-200 rounded-full mx-auto mb-6"></div>
                        <div className="space-y-2 mb-8">
                            <div className="h-5 w-56 bg-gray-200 rounded mx-auto"></div>
                            <div className="h-4 w-40 bg-gray-100 rounded mx-auto"></div>
                        </div>
                        <div className="w-32 h-12 bg-gray-200 rounded-xl mx-auto"></div>
                    </div>

                    {/* Requirements Card Skeleton */}
                    <div className="bg-white rounded-xl border border-gray-200 p-6">
                        <div className="flex items-start space-x-4">
                            <div className="w-6 h-6 bg-gray-200 rounded"></div>
                            <div className="flex-1">
                                <div className="h-5 w-32 bg-gray-200 rounded mb-3"></div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    {[1, 2].map((col) => (
                                        <div key={col}>
                                            <div className="h-4 w-24 bg-gray-200 rounded mb-2"></div>
                                            <div className="space-y-2">
                                                {[1, 2, 3].map((item) => (
                                                    <div key={item} className="flex items-center">
                                                        <div className="w-3 h-3 bg-gray-200 rounded mr-2"></div>
                                                        <div className="h-3 w-32 bg-gray-100 rounded"></div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ExcelUploaderSkeleton
